const isHTML = (value: string) => /<html/gim.test(value)
export default isHTML
